import { useState, useCallback } from 'react';
import RendicontazioneAdminService from '../services/RendicontazioneAdminService/RendicontazioneAdminService';
import { alertService } from '../services/AlertService';
import { handleError } from '../model/handleError';

const useRendicontazioneAdmin = () => {
    // --- GESTIONE DELLO STATO CORRETTA ---
    const [loadingState, setLoadingState] = useState({
        isFinding: false,
        isUpdating: false,
        isLiquidating: false,
    });

    const findRendicontazioni = useCallback(async (filtri) => {
        setLoadingState(prev => ({ ...prev, isFinding: true }));
        try {
            const response = await RendicontazioneAdminService.find(filtri);
            return Array.isArray(response) ? response : (response?.data || []);
        } catch (error) {
            handleError(error);
            return [];
        } finally {
            setLoadingState(prev => ({ ...prev, isFinding: false }));
        }
    }, []);

    const updateStatus = useCallback(async (data) => {
        setLoadingState(prev => ({ ...prev, isUpdating: true }));
        try {
            await RendicontazioneAdminService.updateStatus(data);
            alertService.success("Stato aggiornato con successo.", { autoClose: true });
            return true;
        } catch (error) {
            handleError(error);
            return false;
        } finally {
            setLoadingState(prev => ({ ...prev, isUpdating: false }));
        }
    }, []);
    
    const liquidaRendicontazione = useCallback(async (formData) => {
        setLoadingState(prev => ({ ...prev, isLiquidating: true }));
        try {
            await RendicontazioneAdminService.liquidate(formData);
            alertService.success("Rendicontazione liquidata con successo.", { autoClose: true });
            return true;
        } catch (error) {
            handleError(error);
            return false;
        } finally {
            setLoadingState(prev => ({ ...prev, isLiquidating: false }));
        }
    }, []);

    const findLiquidate = useCallback(async (filtri) => {
         setLoadingState(prev => ({ ...prev, isLiquidating: true }));
        try {
            const response = await RendicontazioneAdminService.findLiquidate(filtri);
            return Array.isArray(response) ? response : (response?.data || []);
        } catch (error) {
            handleError(error);
            return [];
        } finally {
            setLoadingState(prev => ({ ...prev, isLiquidating: false }));
        }
    }, []);

    const getDettaglio = useCallback(async (id_rendicontazione) => {
        setLoadingState(prev => ({ ...prev, isLiquidating: true }));
        try {
            const response = await RendicontazioneAdminService.getDettaglio(id_rendicontazione);
            return Array.isArray(response) ? response : (response?.data || []);
        } catch (error) {
            handleError(error);
            return [];
        } finally {
            setLoadingState(prev => ({ ...prev, isLiquidating: false }));
        }
    }, []);

        // --- NUOVE FUNZIONI PER I SUPERPARTNER ---

    const findSuperpartnerRendicontazioni = useCallback(async (filtri) => {
        setLoadingState(prev => ({ ...prev, isFinding: true }));
        try {
            const response = await RendicontazioneAdminService.findSuperpartner(filtri);
            return Array.isArray(response) ? response : (response?.data || []);
        } catch (error) {
            handleError(error);
            return [];
        } finally {
            setLoadingState(prev => ({ ...prev, isFinding: false }));
        }
    }, []);

    const updateStatusSuperpartner = useCallback(async (data) => {
        setLoadingState(prev => ({ ...prev, isUpdating: true }));
        try {
            await RendicontazioneAdminService.updateStatusSuperpartner(data);
            alertService.success("Stato aggiornato con successo.", { autoClose: true });
            return true;
        } catch (error) {
            handleError(error);
            return false;
        } finally {
            setLoadingState(prev => ({ ...prev, isUpdating: false }));
        }
    }, []);

    const liquidaRendicontazioneSuperpartner = useCallback(async (formData) => {
        setLoadingState(prev => ({ ...prev, isLiquidating: true }));
        try {
            await RendicontazioneAdminService.liquidateSuperpartner(formData);
            alertService.success("Rendicontazione superpartner liquidata con successo.", { autoClose: true });
            return true;
        } catch (error) {
            handleError(error);
            return false;
        } finally {
            setLoadingState(prev => ({ ...prev, isLiquidating: false }));
        }
    }, []);

    const findLiquidateSuperpartner = useCallback(async (filtri) => {
        setLoadingState(prev => ({ ...prev, isFinding: true }));
        try {
            const response = await RendicontazioneAdminService.findLiquidateSuperpartner(filtri);
            return Array.isArray(response) ? response : (response?.data || []);
        } catch (error) {
            handleError(error);
            return [];
        } finally {
            setLoadingState(prev => ({ ...prev, isFinding: false }));
        }
    }, []);

    const getDettaglioSuperpartner = useCallback(async (id_rendicontazione) => {
        setLoadingState(prev => ({ ...prev, isFinding: true }));
        try {
            const response = await RendicontazioneAdminService.getDettaglioSuperpartner(id_rendicontazione);
            return Array.isArray(response) ? response : (response?.data || []);
        } catch (error) {
            handleError(error);
            return [];
        } finally {
            setLoadingState(prev => ({ ...prev, isFinding: false }));
        }
    }, []);


    // Esportiamo sia le vecchie che le nuove funzioni
    return {
        loadingStateAdmin: loadingState,
        findRendicontazioni,
        updateStatus,
        liquidaRendicontazione,
        findLiquidate,
        getDettaglio,
        // Nuove funzioni
        findSuperpartnerRendicontazioni,
        updateStatusSuperpartner,
        liquidaRendicontazioneSuperpartner,
        findLiquidateSuperpartner,
        getDettaglioSuperpartner
    };
};

export default useRendicontazioneAdmin;